<template>
  <transition name="modal">
      <div class="modal-mask">
          <div class="modal-container card">
              <div class="modal-header">
                  <slot name="header"></slot>
                  <a class="modal-close" id="modal-close" @click="close">
                      <icon-close />
                  </a>
              </div>
              <div class="modal-body">
                  <slot name="content"></slot>
              </div>
          </div>
      </div>
  </transition>
</template>

<style lang="sass">

  @import ../../common/styles/settings

  .modal
      &-mask
          position: fixed
          z-index: 4003
          top: 0
          left: 0
          width: 100%
          height: 100%
          background-color: rgba(0, 0, 0, .5)
          display: flex
          align-items: center
          justify-content: center
          transition: opacity .3s ease

      &-header
          .title
          margin: 0 1em 0 0

      &-body
          > * + *,
          > * + .title
              margin-top: $baseline

      &-container
          margin: $baseline*.5
          padding: $baseline*1.5 $baseline
          background-color: $color-background-light
          box-shadow: $card-shadow
          transition: all $speed-fast $authentic-motion
          max-height: calc(95% - 1rem)
          overflow-x: hidden
          overflow-y: auto

          +media('>=small')
              width: 40.625rem
              margin: 0
              padding: $baseline*2

          &.card::before
              +media('<small')
                  content: none

          > * + *
              margin-top: $baseline

      &-close
          display: block
          padding: $baseline*.5
          cursor: pointer
          position: absolute
          right: $baseline
          top: $baseline

          polyline
              stroke: $color-base
              stroke-dasharray: 1.125em 1.125em
              transition: stroke $speed-normal $authentic-motion, stroke-dashoffset $speed-long $authentic-motion
              &:first-child
                  transition-delay: 100ms

          &:hover
              polyline
                  stroke: $color-side
                  &:first-child
                      stroke-dashoffset: -2.25em
                  &:last-child
                      stroke-dashoffset: 2.25em

      &-default-button
          float: right

      &-enter,
      &-leave-active
          opacity: 0

      &-enter .modal-container,
      &-leave-active .modal-container
          transform: translateY($baseline*-1) scale(1.01)


</style>
<script>
  import IconClose from "./icons/IconClose.vue"


  export default {
      name: 'modal',
      components: {
          IconClose
      },
      mounted() {
          document.body.parentNode.style.overflow = 'hidden'
          document.body.style.overflow = 'hidden'
          this.isGTM()
      },
      methods: {
          close() {
              document.body.parentNode.style.overflow = ''
              document.body.style.overflow = ''
              this.$emit('close')
          },
          isGTM(){
              const uriPath = window.location.href;
              const modalClose = document.getElementById("modal-close")

              if (uriPath.includes("user_type")) {
                  modalClose.style.display = "none"
              }
          }
      }
  }
</script>
